import type { ReactNode } from 'react';

interface StatisticsNumberProps {
  children?: ReactNode;
  /** Additional CSS classes to apply to the number. */
  className?: string;
}

export default function StatisticsNumber({ className = '', children }: StatisticsNumberProps) {
  return (
    <span
      className={`font-unibet text-center text-[24px] leading-[24px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark ${className}`}
    >
      {children}
    </span>
  );
}
